<template>
    <div class="patient-bannerList">
        <bread-crumb :bread-list="breadList" />
        <div class="info-wrap">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">banner列表</span>
            </div>
            <div class="select-wrap">
                <div class="option-wrap">
                    <div class="option-item">
                        <span class="label">banner标题</span>
                        <el-input size="small"
                                 placeholder="请输入标题"
                                 :style="{width: '240px'}"
                                 v-model="selectForm.title">

                        </el-input>
                    </div>

                    <div class="option-item">
                        <span class="label">状态</span>
                        <el-select v-model="selectForm.status"
                                   placeholder="请选择"
                                   size="small">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>

                    <div class="option-item">
                        <span class="label">创建日期</span>
                            <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.createTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>
                </div>
                <div class="option-wrap">
                    <div class="option-item">
                        <span class="label">上线日期</span>
                            <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.addedTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>
                    <div class="option-item">
                        <span class="label">创建人</span>
                        <el-input size="small"
                                 placeholder="请输入姓名"
                                 :style="{width: '198px'}"
                                 v-model="selectForm.uploader">

                        </el-input>
                    </div>

                    <div class="select-btn-wrap">
                        <el-button type="primary"
                                   size="small"
                                   @click="handleSearch">查询</el-button>
                        <el-button type="info"
                                   size="small"
                                   plain
                                   @click="resetSearch">重置</el-button>
                    </div>
                </div>

                <div class="option-wrap">
                    <el-button
                        class="add_btn"
                        size="small"
                        @click="handleAddBanner">新增banner</el-button>
                </div>
            </div>
            <div class="table-wrap">
                <el-table :data="dataList"
                          v-loading="loading"
                          stripe
                          style="width: 100%">
                    <el-table-column min-width="60px"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="250px"
                                     label="banner">
                        <template slot-scope="scope">
                            <div class="image_title">
                                <el-image v-if="scope.row.coverPicture"
                                          class="cover-picture"
                                          :src="'/ms-hoc-video/v1/image/download?fileName='+ scope.row.coverPicture">
                                </el-image>
                                <div class="text_title">
                                    <span class="image_text">{{ scope.row.bannerTitle }}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="url"
                                     min-width="180px"
                                     label="URL">
                    </el-table-column>

                    <el-table-column min-width="125px"
                                     label="上线时间">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.addedTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="125px"
                                     label="下线时间">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.dismountedTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="140px"
                                     label="创建时间">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.createTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="uploader"
                                     width="80px"
                                     label="上传人员">
                    </el-table-column>
                    <el-table-column width="120px"
                                     label="状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已上线</span>
                            </div>
                            <div v-else
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item">
                                </el-badge>
                                <span class="status_text">未上线</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right"
                                     label="排序"
                                     width="90">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status && isStatsShow"
                                 class="status-on">
                                <i class="iconfont icon-paixushang icon-off"
                                   v-if="scope.row.noMoveUp"></i>
                                <i class="iconfont icon-paixushang icon-on"
                                   v-else
                                   @click="handleMoveUp(scope.row.bannerId)"></i>

                                <i class="iconfont icon-paixuxia icon-off"
                                   v-if="scope.row.noMoveDown"></i>
                                <i class="iconfont icon-paixuxia icon-on"
                                   v-else
                                   @click="handleMoveDown(scope.row.bannerId)"></i>
                            </div>
                            <div v-else
                                 class="status-off">
                                <i class="iconfont icon-paixushang"></i>
                                <i class="iconfont icon-paixuxia"></i>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right"
                                     label="操作"
                                     width="135">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status">
                                <span @click="handleDismountedBanner(scope.row.bannerId)"
                                      class="link-btn">下线</span>
                            </div>
                            <div v-else>
                                <span @click="handleShelfBanner(scope.row.bannerId)"
                                      class="link-btn">上线</span>

                                <span @click="handleEditorBanner(scope.row.bannerId)"
                                      class="link-btn">编辑</span>
                                <span @click="hanldeDialogVisible(scope.row)"
                                      class="link-btn">删除</span>
                            </div>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg class="icon noneData" aria-hidden="true">
                                <use xlink:href="#icon-none1"></use>
                            </svg>
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="pageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total"></el-pagination>
            </div>

            <message-box :dialog-visible="dialogVisible"
                     :id="bannerId"
                     :warning-text="bannerName"
                     @handleConfirm="handleConfirm"
                     @handleClose="handleClose" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageBox from '@/components/MessageBox'
import shortcuts from '@/utils/pickerOptions'
import { postBannerList, deleteBanner, postDismountedBanner, postShelfBanner, getBannerMoveUp, getBannerMoveDown } from '@/api/patient/banner'
export default {
    name: 'bannerList',
    data () {
        return {
            breadList: [{ label: '内容管理' }, { label: 'banner列表' }],
            datePickerOptions: {
                shortcuts: shortcuts
            },
            selectForm: {
                title: '',
                status: '',
                createTime: '',
                onlineTime: '',
                uploader: ''
            },
            stateList: [
                {
                    label: '全部',
                    value: ''
                },
                {
                    label: '上线',
                    value: true
                },
                {
                    label: '下线',
                    value: false
                }
            ],
            loading: false,
            dataList: [],
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            },
            isStatsShow: true,
            dialogVisible: false,
            bannerName: '',
            bannerId: ''
        }
    },
    components: {
        MessageBox
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    methods: {
        handleClose () {
            this.dialogVisible = false
        },
        handleConfirm (bannerId) {
            this.loading = true
            this.dialogVisible = false
            this.handleDeleteBanner(bannerId)
        },
        pageChange (value) {
            this.page.current = value
            this.query()
        },
        resetSearch () {
            this.selectForm = {
                title: '',
                status: '',
                uploader: '',
                createTime: '',
                addedTime: ''
            }
            this.query(1)
        },
        handleSearch () {
            this.query(1)
        },
        selectChange () {
            this.query(1)
        },
        query (current) {
            this.page.current = current
            this.queryBannerList()
        },
        queryShow () {
            const { bannerTitle, status, uploader, createTime, addedTime } = this.selectForm
            const flag = bannerTitle || status || uploader || createTime || addedTime
            this.isStatsShow = !flag
        },
        async getData () {

        },
        async queryBannerList () {
            let addedTimeStart = ''
            let addedTimeEnd = ''
            if (this.selectForm.addedTime) {
                addedTimeStart = this.selectForm.addedTime[0] + ' 00:00:00'
                addedTimeEnd = this.selectForm.addedTime[1] + ' 23:59:59'
            }
            let createTimeStart = ''
            let createTimeEnd = ''
            if (this.selectForm.createTime) {
                createTimeStart = this.selectForm.createTime[0] + ' 00:00:00'
                createTimeEnd = this.selectForm.createTime[1] + ' 23:59:59'
            }

            const params = {
                hospitalId: this.userInfo.hospitalId,
                bannerTitle: this.selectForm.title,
                status: this.selectForm.status,
                uploader: this.selectForm.uploader,
                addedTimeStart: addedTimeStart,
                addedTimeEnd: addedTimeEnd,
                createTimeStart: createTimeStart,
                createTimeEnd: createTimeEnd,
                size: this.page.pageSize,
                current: this.page.current
            }
            this.loading = true
            this.dataList = []
            const { results, total } = await postBannerList(params)
            if (results && results.length > 0) {
                for (let i = 0; i < results.length; i++) {
                    if (results[0].priority !== 0 && this.page.current === 1) {
                        this.$set(results[0], 'noMoveUp', true)
                    }
                    if (results[i].priority === 1) {
                        this.$set(results[i], 'noMoveDown', true)
                    }
                }
                this.loading = false
                this.dataList = results
                this.page.total = total
            } else {
                if (this.page.current > 1) {
                    this.page.current -= 1
                    this.queryBannerList()
                }
            }
            this.queryShow()
            this.loading = false
        },
        async handleDeleteBanner (bannerId) {
            const { state } = await deleteBanner(bannerId)
            if (state === 200) {
                this.$message({
                    message: '删除banner成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            }
        },
        async handleDismountedBanner (bannerId) {
            this.loading = true
            const { results } = await postDismountedBanner(bannerId)
            if (results === 'successed') {
                this.$message({
                    message: 'banner下线成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            }
        },
        async handleShelfBanner (bannerId) {
            this.loading = true
            const { results } = await postShelfBanner(bannerId)
            this.loading = false

            if (results === 'successed') {
                this.$message({
                    message: 'banner上线成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            } else if (results === 'failed') {
                this.$message.error('上线失败：最多上线五个banner')
            }
        },
        async handleMoveUp (bannerId) {
            const { state } = await getBannerMoveUp(bannerId)
            if (state === 200) {
                this.query(this.page.current)
            }
        },
        async handleMoveDown (bannerId) {
            const { state } = await getBannerMoveDown(bannerId)
            if (state === 200) {
                this.query(this.page.current)
            }
        },
        init () {
            this.queryBannerList()
        },
        handleAddBanner () {
            this.$router.push('/patient/content/addBanner')
        },
        handleEditorBanner (bannerId) {
            this.$router.push({ path: '/patient/content/editorBanner', query: { bannerId: bannerId } })
        },
        hanldeDialogVisible (row) {
            this.bannerId = row.bannerId
            this.bannerName = '确定将banner"李奶奶留言李奶奶留言李奶奶留言"删除'
            // this.bannerName = `确定将banner"${row.bannerTitle}"删除`
            this.dialogVisible = true
        }
    },
    filters: {
        formatDate (value) {
            if (value) {
                return value.substring(0, 16)
            } else {
                return '暂无'
            }
        }
    },
    mounted () {
        this.init()
    }
}
</script>

<style lang="scss">
.patient-bannerList{
    .banner-dialog{
        .el-dialog__body {
            padding: 10px 20px 30px 26px!important;
        }
    }
}
</style>
<style lang="scss" scoped>
.patient-bannerList{
    .info-wrap{
        background-color: #fff;
        -webkit-box-shadow: 0 1px 4px 0 rgba(201, 201, 201, 0.5);
        box-shadow: 0 1px 4px 0 rgba(201, 201, 201, 0.5);
        position: absolute;
        left: 20px;
        right: 20px;
        bottom: 20px;
        top: 50px;
        padding: 20px;
        overflow: auto;

        .title-wrap{
            font-size: 0;
            padding-bottom: 10px;
            height: 16px;
            line-height: 16px;
            border-bottom: 1px solid #CCCCCC;
            margin-bottom: 20px;

            .icon-tongyongbiaotiicon {
                color: #06aea6;
                font-size: 16px;
                vertical-align: middle;
            }

            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }
    }
    .option-item {
        display: inline-block;
        font-size: 0;
        margin-right: 20px;
        margin-bottom: 20px;
        .label {
            padding-right: 10px;
            font-size: 14px;
            color: #666;
            display: inline-block;
            text-align: right;
        }
    }

    .select-btn-wrap {
        display: inline-block;
    }

    .add_btn{
        padding: 9px 15px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #06AEA6;
        text-align: center;
        line-height: 14px;
        border: 1px solid #06AEA6;
        border-radius: 3px;
    }

    .noneData{
        width: 100px;
    }

    .table-wrap{
        margin-top: 20px;
        .image_title {
            display: flex;
            align-content: center;
            .cover-picture {
                width: 70px;
                height: 70px;
            }
            .text_title {
                margin-left: 14px;
                height: 70px;
                width: 144px;
                display: flex;
                align-items: center;
                .image_text {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    line-height: 18px;
                    overflow: hidden;
                    word-break: break-all;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }
            }
        }

        .status-warp {
            line-height: 12px;
            .el-badge {
                height: 10px;
                .el-badge__content {
                    width: 6px;
                    height: 6px;
                }
                .el-badge__content--success {
                    background: #4acfb1;
                }
                .el-badge__content--info {
                    background: #cccccc;
                }
            }
            .status_text {
                margin-left: 10px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #333333;
                line-height: 12px;
            }
        }

        .status-on {
            .icon-off {
                color: #ccc;
            }
            .icon-on {
                cursor: pointer;
                color: #3b8fd9;
            }
            .icon-paixuxia {
                font-size: 16px;
            }
            .icon-paixushang {
                font-size: 16px;
                margin-right: 20px;
            }
        }

        .status-off {
            .icon-paixuxia {
                font-size: 16px;
                color: #ccc;
            }
            .icon-paixushang {
                font-size: 16px;
                color: #ccc;
                margin-right: 20px;
            }
        }

        .link-btn {
            color: $a-link;
            cursor: pointer;
            font-size: 12px;
            display: inline-block;
            height: 14px;
            line-height: 14px;
            border-right: 1px solid $a-link;
            margin-right: 6px;
            padding-right: 6px;
            &:last-child {
                border-right: none;
                margin-right: 0;
                padding-right: 0;
            }
        }
    }
}

</style>
